"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updates(_ref) {
  var list = _ref.list;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "update"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "heading"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement("span", null, "!")), "Update"), /*#__PURE__*/_react.default.createElement("div", {
    className: "update-list"
  }, list.map(function (_ref2) {
    var id = _ref2.id,
        title = _ref2.title,
        description = _ref2.description;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "update-list-item",
      key: id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "update-list-item-title"
    }, title), /*#__PURE__*/_react.default.createElement("p", null, description));
  })));
}

updates.propTypes = {
  list: _propTypes.default.array.isRequired
};
var _default = updates;
exports.default = _default;